import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import SearchBar from '@/components/base/SearchBar';

const navItems = [
  { label: '首页', to: '/' },
  { label: '电视剧分类', to: '/category/tv-series' },
  { label: '影视资讯', to: '/category/news' },
  { label: '演员动态', to: '/category/actors' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 rounded-md text-sm font-label transition-colors whitespace-nowrap cursor-pointer ${
      isActive ? 'text-primary-700 bg-primary-100' : 'text-foreground-700 hover:text-primary-700 hover:bg-background-100'
    }`;

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full max-w-page mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between gap-4 h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950 flex items-center justify-center">
              <i className="ri-movie-2-line text-lg"></i>
            </span>
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap">漂亮的姐姐</span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 flex-1 justify-center">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === '/'}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:block w-72 shrink-0">
            <SearchBar />
          </div>

          <Link
            to="/search"
            aria-label="搜索"
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-search-line text-lg"></i>
          </Link>

          <button
            type="button"
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <div className="px-4 py-4 flex flex-col gap-3">
            <SearchBar />
            <nav className="flex flex-col gap-1">
              {navItems.map((item) => (
                <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === '/'}>
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      ) : null}
    </header>
  );
}